import React from 'react';

import { ImageGridLayout } from '../image-grid';

export const layoutForImageGrid = (
	imageGalleryDisplay?: Queries.ContentfulArticleBlock['imageGalleryDisplay']
): ImageGridLayout | undefined => {
	switch (imageGalleryDisplay) {
		case 'Block of 2 images':
			return ImageGridLayout.TwoImages;
		case 'Block of 5 images':
			return ImageGridLayout.FiveImages;
		case 'Block of 6 images':
			return ImageGridLayout.SixImages;
		default:
			return;
	}
};
